<div class="renal-graph">
  <!--Circle graph-->
  <div
    class="renal-graph__circle"
    [class.status-not-at-risk]="status === RenalDetectStatus.NotAtRisk"
    [class.status-at-risk]="status === RenalDetectStatus.AtRisk"
    [class.status-cdk]="status === RenalDetectStatus.CKD"
  >
    <svg width="34px" height="30px" viewBox="0 0 34 30">
      <g id="Sprint" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Desktop-_1440" transform="translate(-431.000000, -415.000000)" fill="#FFFFFF" fill-rule="nonzero">
          <g id="CKD" transform="translate(260.000000, 275.000000)">
            <g id="Group-5" transform="translate(58.000000, 108.000000)">
              <g id="Group" transform="translate(56.000000, 0.000000)">
                <path
                  d="M68.3125132,33.5479419 C69.261568,33.2590992 70.2091152,33.3990778 70.9782978,33.9658439 C71.6970761,34.49547 72.1412652,35.3094143 72.2010535,36.1839345 L72.2079772,36.3867203 L72.2079772,39.6023941 C72.2079772,40.2548387 71.6762359,40.78658 71.0237913,40.78658 C70.4121244,40.78658 69.9065445,40.3192293 69.8457363,39.7232126 L69.8396053,39.6023941 L69.8396053,36.3867203 C69.8396053,36.1772046 69.7597603,36.0081211 69.5879142,35.8919547 C69.4275349,35.7672153 69.2592315,35.7413225 69.0552028,35.8024442 C65.1730166,37.0447438 61.8643589,40.7917986 60.2922847,48.1557221 C59.4704896,52.0345949 59.8476596,54.9043667 61.342875,56.6860491 C62.9517904,58.5285167 65.6805069,59.0900787 68.9485297,58.8758829 C69.3982874,58.8554394 69.7769829,58.4860371 69.8325825,58.0221582 L69.8396053,57.9043674 L69.8396053,47.8126251 C69.8396053,47.1601805 70.3713466,46.6284392 71.0237913,46.6284392 C71.6173463,46.6284392 72.1123288,47.0686709 72.2241851,47.6792726 L72.2421865,47.8126251 L72.2421865,57.9385767 C72.2421865,59.6754804 70.8726568,61.156053 69.1080707,61.2779483 L67.9784801,61.3104353 L67.7739081,61.3121576 C64.4236372,61.3121576 61.4954971,60.4111914 59.5957772,58.2311774 C57.5237041,55.8319349 56.9950029,52.2833642 57.9802536,47.6386281 C59.7338911,39.5209831 63.5385653,35.1783711 68.0508151,33.6340935 L68.3125132,33.5479419 Z M77.0017505,33.9215089 C77.7846298,33.3858546 78.7662238,33.2314466 79.6623692,33.5165947 C84.3352588,35.0366913 88.2329414,39.3674497 90.0201374,47.6404544 C91.0055812,52.2861182 90.4754928,55.8350152 88.4027661,58.1986473 C86.572298,60.2991845 83.7842021,61.2119643 80.5834065,61.2744836 L80.2260919,61.2779483 L79.4806755,61.2733213 L79.2031508,61.2653026 L78.9683614,61.2517654 L78.8571302,61.2425266 C77.1891213,61.1261538 75.8560966,59.7452917 75.7630081,58.0894331 L75.7578135,57.9043674 L75.7578135,47.8126251 C75.7578135,47.1601805 76.2895548,46.6284392 76.9419995,46.6284392 C77.5536663,46.6284392 78.0592462,47.09579 78.1200544,47.6918066 L78.1261854,47.8126251 L78.1261854,57.8701581 C78.1261854,58.3573918 78.537983,58.7975893 79.0354038,58.8428291 C82.1654408,59.0993895 85.0026811,58.5072698 86.6228201,56.6519493 C88.1518603,54.8999241 88.5284496,52.0345709 87.6740438,48.1240198 C86.0724571,40.7511979 82.7717845,37.0038178 78.9193019,35.770936 C78.7314523,35.7145811 78.5194151,35.7516876 78.3709062,35.8630693 C78.2377744,35.9629182 78.1565839,36.0942855 78.1332185,36.2535984 L78.1261854,36.352511 L78.1261854,39.5681848 C78.1261854,40.2206295 77.5944441,40.7523707 76.9419995,40.7523707 C76.3303326,40.7523707 75.8247527,40.28502 75.7639445,39.6890033 L75.7578135,39.5681848 L75.7578135,36.352511 C75.7578135,35.4489745 76.1424778,34.6338716 76.8247917,34.0597716 L77.0017505,33.9215089 Z M74,32.5 C74.6116668,32.5 75.1172468,32.9673507 75.1780549,33.5633674 L75.1841859,33.6841859 L75.184,40.525 L80.74,46.113 L83.7906954,47.1968748 C84.3383642,47.3611755 84.6748833,47.9327264 84.588988,48.4765035 L84.5640393,48.5924435 L84.5256976,48.7065821 C84.3514454,49.1712547 83.8947156,49.4757412 83.4075564,49.4757412 C83.2350185,49.4757412 83.1401065,49.4690296 83.0601609,49.4396673 L83.0020288,49.4131496 L81.239,48.792 L81.2392313,50.6177874 C81.2392313,51.1886765 80.8321169,51.667152 80.2932513,51.7778508 L80.1758639,51.7958423 L80.0550454,51.8019733 C79.4433785,51.8019733 78.9377986,51.3346226 78.8769905,50.7386059 L78.8708595,50.6177874 L78.87,47.574 L74.001,42.705 L69.163,47.574 L69.1633498,50.5835781 C69.1633498,51.1544672 68.7562354,51.6329427 68.2173699,51.7436415 L68.0999824,51.761633 L67.9791639,51.767764 C67.3674971,51.767764 66.8619172,51.3004133 66.801109,50.7043966 L66.794978,50.5835781 L66.794,48.758 L65.0242319,49.3816643 C64.9510028,49.406074 64.8895297,49.4210409 64.827403,49.4299054 L64.7321717,49.4390428 L64.6266529,49.4415319 L64.4947381,49.4340987 C64.0588189,49.3849306 63.6672798,49.0957237 63.5124379,48.6825064 C63.2877069,48.1206787 63.5619732,47.5047266 64.1006017,47.2250143 L64.2199829,47.1703648 L67.295,46.079 L72.815,40.525 L72.8158141,33.6841859 C72.8158141,33.1132969 73.2229285,32.6348213 73.761794,32.5241226 L73.8791815,32.506131 L74,32.5 Z"
                  id="Shape"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
    <p class="renal-graph__circle-text">
      {{ renalDetectRecommendationDetails.titleStatusText }}
    </p>
  </div>

  <!--Gauge graph-->
  <div class="renal-graph__gauge" [style.height]="50" [style.width]="fullWidth">
    <svg
      width="11px"
      height="8px"
      viewBox="0 0 11 8"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      [class.arrow-not-at-risk]="status === RenalDetectStatus.NotAtRisk"
      [class.arrow-cdk]="status === RenalDetectStatus.CKD"
    >
      <g id="Sprint" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Desktop-_1440" transform="translate(-443.000000, -551.000000)" fill="#333333">
          <g id="CKD" transform="translate(260.000000, 275.000000)">
            <g id="Group-5" transform="translate(58.000000, 108.000000)">
              <g id="Group-4" transform="translate(0.000000, 163.000000)">
                <polygon
                  id="Rectangle"
                  transform="translate(130.356155, 6.356155) rotate(45.000000) translate(-130.356155, -6.356155) "
                  points="133.424621 2 134.712311 10.7123106 126 9.4246212"
                ></polygon>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
    <svg class="progress-svg" [attr.height]="25" [attr.width]="fullWidth" overflow="hidden">
      <line
        [attr.x1]="fullWidth / 3"
        [attr.y1]="centeredPosition"
        [attr.x2]="(fullWidth * 2) / 3"
        [attr.y2]="centeredPosition"
        [style.stroke]="'#EE8B00'"
        [style.strokeWidth]="height"
      />
      <line
        x1="5"
        [attr.y1]="centeredPosition"
        [attr.x2]="rectSize"
        [attr.y2]="centeredPosition"
        stroke-linecap="butt"
        [style.stroke]="'#008900'"
        [style.strokeWidth]="height"
      />
      <line
        x1="5"
        [attr.y1]="centeredPosition"
        [attr.x2]="rectSize - 5"
        [attr.y2]="centeredPosition"
        stroke-linecap="round"
        [style.stroke]="'#008900'"
        [style.strokeWidth]="height"
      />
      <line
        [attr.x1]="fullWidth - rectSize"
        [attr.y1]="centeredPosition"
        [attr.x2]="fullWidth - 6"
        [attr.y2]="centeredPosition"
        stroke-linecap="butt"
        [style.stroke]="'#CF1D40'"
        [style.strokeWidth]="height"
      />
      <line
        [attr.x1]="fullWidth - rectSize + 5"
        [attr.y1]="centeredPosition"
        [attr.x2]="fullWidth - 5"
        [attr.y2]="centeredPosition"
        stroke-linecap="round"
        [style.stroke]="'#CF1D40'"
        [style.strokeWidth]="height"
      />
    </svg>
    <div class="renal-graph-legend">
      <p
        class="renal-graph-level"
        [ngStyle]="{
          opacity: status === RenalDetectStatus.NotAtRisk ? '1' : '0.5',
        }"
        i18n="@@rd-label-not-at-risk"
      >
        Not at risk
      </p>
      <p
        class="renal-graph-level"
        [ngStyle]="{
          opacity: status === RenalDetectStatus.AtRisk ? '1' : '0.5',
        }"
        i18n="@@rd-label-at-risk"
      >
        At risk
      </p>
      <p class="renal-graph-level" [ngStyle]="{ opacity: status === RenalDetectStatus.CKD ? '1' : '0.5' }" i18n="@@rd-label-ckd">CKD</p>
    </div>
  </div>

  <p class="renal-graph-title">
    {{ renalDetectRecommendationDetails.statusText }}
    <span>*</span>
  </p>
</div>
